module.exports = __webpack_public_path__ + "static/coffee-7510af1ad006102f788f8d04736c85d1.jpg";